var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors)?_c('div',{staticClass:"border-danger alert d-flex",attrs:{"role":"alert"}},[_c('p',{staticClass:"text-danger mb-0 my-auto"},[_vm._v(_vm._s(_vm.errors.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }